import { ApiService } from '../services/index';
import { accessTokenStorage } from '../storage/auth/index';
import { getJwtExpMs } from '../utils/jwt-exp-ms.util';

/** If access token expires within this window, attempt refresh before a WS handshake. */
const REFRESH_IF_EXPIRES_WITHIN_MS = 120_000;

export const ensureFreshAccessTokenForWs = async (): Promise<void> => {
  const token = accessTokenStorage.getState().get() || '';
  if (!token) return;
  const expMs = getJwtExpMs(token);
  if (expMs !== null && expMs > Date.now() + REFRESH_IF_EXPIRES_WITHIN_MS) return;
  try {
    await ApiService.refreshTokens();
  } catch {
    // Proceed with whatever token remains; user may need to re-auth via HTTP.
  }
};
